{
	"optionsOrders": {
		"activeOrders": {
			"filled": "Исполненные",
			"open": "Открытые",
			"canceled": "Отменeнные"
		},
		"ticker": "Тикер",
		"option": "Опцион",
		"tickerCompany": "Тикер/Комп",
		"operation": "Операция",
		"quantity": "Кол-во",
		"sum": "Сумма",
		"profitability": "Доходность",
		"dateTime": "Дата/Время",
		"actions": "Действия",
		"price": "Цена",
		"openedOrders": "Открытые ордера",
		"statusTitle": "Статус",
		"term": "Срок",
		"orderStatus": "Статус ордера",
		"orderType": "Тип ордера",
		"executed": "Исполнено"
	}
}
